import { PROJECTS_REDUCER_NAME } from './Constants';

const useProjectList = ({ [PROJECTS_REDUCER_NAME]: { projects } }) => projects;

const useProjectByProjectId =
  projectId =>
  ({ [PROJECTS_REDUCER_NAME]: { projects } }) =>
    projects.find(({ id }) => id === projectId);

export { useProjectList, useProjectByProjectId };
